import { createContractRequest } from './helper';
export const putApplication = createContractRequest({
    route: '/contract/offers/:offerId/application',
    method: 'put',
    source: 'data',
    responseCode: 201,
});
